import React, { FC, SVGProps } from "react";

export const IconReceive: FC<SVGProps<SVGSVGElement> & { size?: number }> = ({
  size = 20,
  ...props
}) => {
  return (
    <svg width={size} height={size} viewBox="0 0 21 20" fill="none" {...props}>
      <path
        d="M16.3333 11.6667H13V2.5H7.99996V11.6667H4.66663L10.5 17.5L16.3333 11.6667Z"
        fill="currentColor"
      />
    </svg>
  );
};
